export default __webpack_public_path__ + "static/philip2-c41dbfebb057c070f57739aeda71f6a6.jpg";